export enum GbxsoftInputTypes {
  TEXT = 'text',
  NUMBER = 'number',
  PRICE = 'price',
  NON_NEGATIVE_INTEGER = 'non-negative-integer',
  CALENDAR = 'calendar',
  PASSWORD = 'password',
  RANGE_CALENDAR = 'range-calendar',
}
